import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Pusher from 'pusher-js';
import Application from 'flarum/common/Application';
import RealtimeState from '../RealtimeState';
import NotificationToast from '../components/NotificationToast';
import NotificationToastState from '../states/NotificationToastState';
export default function () {
  extend(Application.prototype, 'mount', function () {
    // Enable logging to console when debug is enabled.
    Pusher.logToConsole = this.forum.attribute('debug');
    const wsHost = this.forum.attribute('websocket.host');
    const secure = this.forum.attribute('websocket.secure');
    app.websocket = new Pusher(this.forum.attribute('websocket.key'), {
      channelAuthorization: {
        endpoint: this.forum.attribute('apiUrl') + '/websocket/auth',
        transport: 'ajax'
      },
      wsHost,
      wsPort: this.forum.attribute('websocket.port'),
      wssPort: this.forum.attribute('websocket.port'),
      enabledTransports: ['wss', 'ws'],
      forceTLS: secure
    });
    app.websocket_channels = {
      public: null,
      user: null
    };

    // Mount the notification toast container outside the main Mithril tree.
    const toastState = new NotificationToastState();
    const toastEl = document.createElement('div');
    document.body.appendChild(toastEl);
    m.mount(toastEl, {
      view: () => m(NotificationToast, {
        state: toastState
      })
    });
    if (app.session.user) {
      const userChannel = app.websocket.subscribe('private-user=' + app.session.user.id());
      app.websocket_channels.user = userChannel;
      RealtimeState.notifyUserChannelReady(userChannel);

      // Show a toast for each incoming realtime notification and update the badge count.
      userChannel.bind('notification', data => {
        const notification = app.store.pushPayload(data);
        if (notification) {
          var _user$unreadNotificat, _user$newNotification;
          const user = app.session.user;
          user == null || user.pushAttributes({
            unreadNotificationCount: ((_user$unreadNotificat = user.unreadNotificationCount()) != null ? _user$unreadNotificat : 0) + 1,
            newNotificationCount: ((_user$newNotification = user.newNotificationCount()) != null ? _user$newNotification : 0) + 1
          });
          toastState.push(notification);
        }
      });
    } else if (!this.forum.attribute('websocket.disallow_connection')) {
      const publicChannel = app.websocket.subscribe('public');
      app.websocket_channels.public = publicChannel;
      RealtimeState.notifyPublicChannelReady(publicChannel);
    }
  });
}